// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"414":"searchModal","574":"industryInsights","614":"industryEvents","622":"searchPage","863":"newsArticles"}[chunkId] + "-" + chunkId + ".css";
};